import { NgModule } from '@angular/core';
import { EntityDataService, EntityServices } from '@ngrx/data';
import { CommunicationConfigurationEmailSenderRepository } from './impl/service/repository/communicationConfigurationEmailSender.repository';
import { CommunicationConfigurationEmailSenderDataService } from './impl/service/repository/communicationConfigurationEmailSender.dataservice';

@NgModule({
})
export class CommunicationConfigurationEmailSenderModule {
    constructor(
        entityDataService: EntityDataService,
        entityServices: EntityServices,
        repository: CommunicationConfigurationEmailSenderRepository,
        dataService: CommunicationConfigurationEmailSenderDataService
    ) {
        entityDataService.registerServices({
            CommunicationConfigurationEmailSender: dataService,
        });

        entityServices.registerEntityCollectionServices({
            CommunicationConfigurationEmailSender: repository,
        });
    }
}